import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseLicensePage } from '@components/shared/license/base.license.page';
import { WARNING_LEVELS } from '@components/shared/license/license.constants';
import {
    ILicense,
    LicenseOfficeType,
} from '@models';
import {
    licenseOfficeType,
    LicenseUrlMap,
    SignalRService,
} from '@services';

import {
    switchMap,
    takeUntil,
    throttleTime,
} from 'rxjs/operators';

@Component({
    templateUrl: './license.page.html',
    styleUrls: ['./license.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicensePageComponent extends BaseLicensePage<ILicense>
    implements OnInit {

    public officeTypeDefinition = LicenseOfficeType;
    public warningLevels = WARNING_LEVELS;

    public set type(type: string) {
        const mappedtype = (type || '').toLowerCase() as keyof typeof LicenseUrlMap;
        if (this._type === mappedtype) { return; }
        this._type = mappedtype;

        this._cd.markForCheck();
    }

    public get type() {
        return LicenseUrlMap[this._type];
    }

    public get officeType(): LicenseOfficeType {
        return licenseOfficeType(LicenseUrlMap[this._type]);
    }

    private _type!: keyof typeof LicenseUrlMap;

    private _signalRService = this._injector.get<SignalRService>(SignalRService);

    ngOnInit() {
        const route = this._injector.get<ActivatedRoute>(ActivatedRoute);
        route.paramMap
            .pipe(
                takeUntil(this._destroyed$),
            )
            .subscribe(params => this.type = params.get('type')!);

        if (!this._type) {
            // make sure we have fresh data on overview
            this._appState.user.license
                .fetch()
                .subscribe();
        }

        this._signalRService.licenseUsage$
            .pipe(
                throttleTime(150),
                switchMap(() => this._appState.user.license.fetch()),
                takeUntil(this._destroyed$),
            )
            .subscribe(() => {
                this._cd.detectChanges();
            });
    }

    public onRemove(payload: { deactivate: boolean, hostLicenseId?: number }) {
        this._onRemove(payload.deactivate && !payload.hostLicenseId);
    }
}
